export default {
    A1: {
        t: 's',
        v: '',
        s: {
            fill: { fgColor: { rgb: 'fff3cc' } },
        },
    },
    A2: {
        t: 's',
        v: '系統編號',
        s: {
            fill: { fgColor: { rgb: 'fff3cc' } },
        },
    },
    B1: {
        t: 's',
        v: '',
        s: {
            fill: { fgColor: { rgb: 'fff3cc' } },
        },
    },
    B2: {
        t: 's',
        v: '借款名稱',
        s: {
            fill: { fgColor: { rgb: 'fff3cc' } },
        },
    },
    C1: {
        t: 's',
        v: '平均攤還',
        s: {
            fill: { fgColor: { rgb: 'b6d7a8' } },
        },
    },
    C2: {
        t: 's',
        v: '總額度',
        s: {
            fill: { fgColor: { rgb: 'b6d7a8' } },
        },
    },
    D1: {
        t: 's',
        v: '',
        s: {
            fill: { fgColor: { rgb: 'b6d7a8' } },
        },
    },
    D2: {
        t: 's',
        v: '貸款利率',
        s: {
            fill: { fgColor: { rgb: 'b6d7a8' } },
        },
    },
    E1: {
        t: 's',
        v: '',
        s: {
            fill: { fgColor: { rgb: 'b6d7a8' } },
        },
    },
    E2: {
        t: 's',
        v: '還款期數',
        s: {
            fill: { fgColor: { rgb: 'b6d7a8' } },
        },
    },
    F1: {
        t: 's',
        v: '',
        s: {
            fill: { fgColor: { rgb: 'b6d7a8' } },
        },
    },
    F2: {
        t: 's',
        v: '已還款',
        s: {
            fill: { fgColor: { rgb: 'b6d7a8' } },
        },
    },
    G1: {
        t: 's',
        v: '',
        s: {
            fill: { fgColor: { rgb: 'b6d7a8' } },
        },
    },
    G2: {
        t: 's',
        v: '還款進度',
        s: {
            fill: { fgColor: { rgb: 'b6d7a8' } },
        },
    },
    H1: {
        t: 's',
        v: '',
        s: {
            fill: { fgColor: { rgb: 'b6d7a8' } },
        },
    },
    H2: {
        t: 's',
        v: '未還款金額',
        s: {
            fill: { fgColor: { rgb: 'b6d7a8' } },
        },
    },
    I1: {
        t: 's',
        v: '',
        s: {
            fill: { fgColor: { rgb: 'b6d7a8' } },
        },
    },
    I2: {
        t: 's',
        v: '還款期限',
        s: {
            fill: { fgColor: { rgb: 'b6d7a8' } },
        },
    },
    J1: {
        t: 's',
        v: '循環額度',
        s: {
            fill: { fgColor: { rgb: 'c9dbf8' } },
        },
    },
    J2: {
        t: 's',
        v: '總額度',
        s: {
            fill: { fgColor: { rgb: 'c9dbf8' } },
        },
    },
    K1: {
        t: 's',
        v: '',
        s: {
            fill: { fgColor: { rgb: 'c9dbf8' } },
        },
    },
    K2: {
        t: 's',
        v: '貸款利率',
        s: {
            fill: { fgColor: { rgb: 'c9dbf8' } },
        },
    },
    L1: {
        t: 's',
        v: '',
        s: {
            fill: { fgColor: { rgb: 'c9dbf8' } },
        },
    },
    L2: {
        t: 's',
        v: '還款期限天數',
        s: {
            fill: { fgColor: { rgb: 'c9dbf8' } },
        },
    },
    M1: {
        t: 's',
        v: '',
        s: {
            fill: { fgColor: { rgb: 'c9dbf8' } },
        },
    },
    M2: {
        t: 's',
        v: '可用額度',
        s: {
            fill: { fgColor: { rgb: 'c9dbf8' } },
        },
    },
    N1: {
        t: 's',
        v: '',
        s: {
            fill: { fgColor: { rgb: 'c9dbf8' } },
        },
    },
    N2: {
        t: 's',
        v: '額度到期日',
        s: {
            fill: { fgColor: { rgb: 'c9dbf8' } },
        },
    },
    '!ref': 'A1:N2',
    '!merges': [
        { s: { c: 2, r: 0 }, e: { c: 8, r: 0 } },
        { s: { c: 9, r: 0 }, e: { c: 13, r: 0 } },
    ],
};
